import { render, staticRenderFns } from "./ModeloVeiculoForm.vue?vue&type=template&id=1e048682"
import script from "./ModeloVeiculoForm.vue?vue&type=script&lang=js"
export * from "./ModeloVeiculoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports